// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_StoreInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /caixa/abrir
 *
 * Valida a requisição de abertura de um novo caixa.
 */
import { registerContract } from './validate'

export interface Caixa_StoreInput {
franquia_id: number
saldo_inicial?: number
observacao?: string
}

registerContract('Caixa_StoreInput', {
  franquia_id:   { type: 'number',  required: true },
  saldo_inicial: { type: 'number',  required: false },
  observacao:    { type: 'string',  required: false },
})
